let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fwm7q")).then(() => parcelRequire('dpbjJ'));